module.exports = __webpack_public_path__ + "1cc9f5ad3504424fc657ffcfb2ba1b07.ttf";